export default "__VITE_ASSET__Cy_u$TDq__"